/**
 * @file   src\components\PlanUpgrade\ShowEditProfileModal.js
 * @brief  This file is responsible for showing edit profile modal after switching to agent
 * @date   July, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import EditProfileModal from "../MemberWantAd/v2/EditProfileModal";

const ShowEditProfileModal = (props) => {
  const { userDetails, selectedPlan } = props;

  return (
    <EditProfileModal
      userDetails={userDetails}
      show={props.editProfileModal}
      onHide={props.EditProfileModalClose}
      isFromUpgradeToAgent={true}
      selectedPlan={selectedPlan}
    />
  );
};

export default ShowEditProfileModal;
